export class InsightsError extends Error {
    constructor(code, message, info) {
        super(message);
        this.code = code;
        this.info = info;
        this.isInsightsError = true;
        this.sampleRate = null;
        this._message = '';
        this.info = info;
        // This is easier to do with defineProperty rather than getter/setters because this way we're able
        // to override the existing `message` property of the Error object.
        Object.defineProperty(this, 'message', {
            get: () => `[${this.code}] ${this._message}`,
            set: (newMessage) => (this._message = newMessage)
        });
        this.message = message;
    }
}
export const isInsightsError = (error) => {
    return typeof error === 'object' && error.hasOwnProperty('isInsightsError') && error.isInsightsError === true;
};
